<template>
  <div class="template-grid">
    <div
      class="template-card"
      :class="{ 'template-disabled': item.disabled }"
      v-for="item in templateList"
      :key="item.type"
      @click="item.disabled ? message.info('该功能暂未开放，敬请期待') : $emit('draft', item.type)"
    >
      <div class="cards-header">
        <!-- 替换为本地图片img -->
        <div class="icon-box">
          <img :src="item.iconSrc" class="card-icon" />
        </div>
        <!-- 标题单独一行 -->
        <div class="title-wrap">
          <h3>{{ item.title }}</h3>
        </div>
      </div>
      <!-- 详情描述独占一行 -->
      <p class="card-desc">{{ item.desc }}</p>
      <div class="card-footer">
        <span class="tag">{{ item.tag }}</span>
        <a type="link">开始起草 →</a>
      </div>
    </div>
  </div>
</template>

<script setup>
defineOptions({ name: "DocumentTemplateList" })
import { ref } from "vue";
import { message } from 'ant-design-vue'
// 移除ant图标导入，不再使用FileTextOutlined
defineEmits(["draft"])

// 模板配置数组，新增iconSrc本地图片路径
const templateList = ref([
  {
    type: "complaint",
    title: "起诉状",
    desc: "根据案件事实、诉讼请求、证据材料生成民事起诉状。",
    tag: "诉讼文书",
    iconSrc: require("@/assets/docImg/icon1.png"),
    disabled: false
  },
  {
    type: "reply",
    title: "答辩状",
    desc: "针对原告诉讼请求、事实理由与证据生成答辩意见。",
    tag: "诉讼文书",
    iconSrc: require("@/assets/docImg/icon2.png"),
    disabled: true
  },
  {
    type: "appeal",
    title: "上诉状",
    desc: "围绕一审裁判事实认定、程序和法律适用问题生成上诉状。",
    tag: "诉讼文书",
    iconSrc: require("@/assets/docImg/icon3.png"),
    disabled: true
  },
  {
    type: "defense",
    title: "辩护意见",
    desc: "围绕事实认定、证据采信、法律适用生成刑事辩护意见。",
    tag: "诉讼文书",
    iconSrc: require("@/assets/docImg/icon4.png"),
    disabled: true
  },
  {
    type: "evidence",
    title: "根据上传证据生成证据清单",
    desc: "上传证据材料，自动提取证据名称、来源、页码和证明目的。",
    tag: "材料驱动",
    iconSrc: require("@/assets/docImg/icon5.png"),
    disabled: true
  }
])
</script>

<style scoped lang="less">
.template-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;

  @media (max-width: 1200px) {
    grid-template-columns: repeat(2, 1fr);
  }
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
}

.template-card {
  background: #fff;
  border: 1px solid #DFE6F2;
  border-radius: 12px;
  padding: 20px;
  cursor: pointer;
  transition: all 0.2s;

  &:hover {
    box-shadow: 0 4px 16px rgba(35, 68, 120, 0.08);
    border-color: #4080ff;
  }

  &.template-disabled {
    cursor: not-allowed;
    opacity: 0.55;

    &:hover {
      box-shadow: none;
      border-color: #DFE6F2;
    }
  }

  .cards-header {
    display: flex;
    gap: 12px;
    align-items: center;
    margin-bottom: 10px;

    .icon-box {
      width: 36px;
      height: 36px;
      border-radius: 8px;
      display: flex;
      align-items: center;
      justify-content: center;
      background: #f0f5ff;
      flex-shrink: 0;
      .card-icon {
        width: 22px;
        height: 22px;
        object-fit: contain;
      }
    }

    .title-wrap h3 {
      font-size: 16px;
      font-weight: 600;
      color: #12213F;
      margin: 0;
    }
  }

  /* 描述文本单独独占一行 */
  .card-desc {
    font-size: 13px;
    color: #64748F;
    margin: 0 0 16px 0;
    line-height: 1.6;
  }

  .card-footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .tag {
      font-size: 12px;
      color: #86909c;
    }
  }
}
</style>